export class ApplicationType
{
    ApplicationID : number;
    ApplicationName : string;
    ApplicationDescription : string;
    IsActive: boolean = true;
    ModifiedBy: number;
}